import React from "react";

import { EighteenHoleIcon } from "./EighteenHoleIcon";
import { NineHoleIcon } from "./NineHoleIcon";

export type HoleCount = "EIGHTEEN" | "NINE" | "NONE";

export const HoleCountIcon = ({ holeCount }: { holeCount: HoleCount }) => {
  switch (holeCount) {
    case "EIGHTEEN":
      return <EighteenHoleIcon testID="EIGHTEEN-HOLE-ICON" />;
    case "NINE":
      return <NineHoleIcon testID="NINE-HOLE-ICON" />;
    case "NONE":
    default:
      return null;
  }
};
